"use client";
import { Box } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Banner } from "./banner";
import { Banner_T } from "./banner/banner";
import { NavContent, NavContent_T } from "./nav-content";
import { getDashboardUrl, getWebUrl } from "@areahub/config";
import { Button_T } from "@ui/components";

export type NavBar_T = PropsWithChildren<{
  navigation: NavContent_T;
  banner?: Banner_T;
}>;

export const NavBar = ({ banner, navigation, children }: NavBar_T) => {
  const buttons = navigation?.buttons?.map((button: Button_T) => {
    if (button.__type === "LINK" && button?.href === "/individuals/pricing") {
      if (process.env.APP_NAME === "WWW") {
        return {
          ...button,
          href: `${getWebUrl()}${button?.href}`,
        };
      } else {
        return {
          ...button,
          href: `${getDashboardUrl()}/pricing/pro-report`,
        };
      }
    }
    return button;
  });

  return (
    <>
      {/* We render the banner at z level 9 and the headroom element at z level 10. */}
      <Box style={{ zIndex: 10 }} position="sticky" top="0">
        <Box
          as="header"
          bg="white"
          shadow={{
            base: "sm",
          }}
        >
          <Box as="nav" aria-label="Main navigation">
            <NavContent.Mobile {...navigation} buttons={buttons} />
            <NavContent.Desktop {...navigation} buttons={buttons} />
          </Box>
        </Box>
      </Box>
      {/* Add the banner outside of headroom to make it not "sticky" */}
      {banner ? <Banner {...banner} zIndex="9" /> : children}
    </>
  );
};
